import React from 'react';
import './DisplayPill.scss';

const DisplayPill = ({ dataTestId, children, forUserView }) => {
  return (
    <div
      className={forUserView ? 'display-pill user-view' : 'display-pill'}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};

export default DisplayPill;
